import request from '@/utils/request'

export function getHomePage(query) {
  return request({
    url: '/home/api/homePage',
    method: 'POST',
    params:query
  })
}